import { PickingItemInterface } from '@app/core/picklists/store/picklist.model';
import { RFQ } from '@app/core/quotes';
import { UnitMeasureInterface } from '@app/modules/unit-measurement/interfaces';
import { IApproval } from 'v2/modules';
import { IWarehouseGroup } from 'v2/modules/shared/interfaces/location-warehouse.interface';
import { ITag } from 'v2/modules/tag/interfaces/tag.interface';

export interface SalesOrder {
  id :number;
  created_at :Date;
  updated_at :Date;
  orderId :number;
  orderNumber :string;
  orderKey :string;
  orderDate :Date;
  createDate :Date;
  modifyDate :Date;
  paymentDate ?:Date;
  shipByDate ?:Date;
  orderStatus :string;
  customerId ?:number;
  customerUsername ?:string;
  customerEmail ?:string;
  billTo ?:string;
  shipTo ?:string;
  items :SalesOrderItem[];
  orderTotal :number;
  amountPaid :number;
  taxAmount :number;
  shippingAmount :number;
  customerNotes ?:string;
  internalNotes ?:string;
  gift ?:number;
  giftMessage ?:string;
  paymentMethod ?:string;
  requestedShippingService ?:string;
  carrierCode ?:string;
  serviceCode ?:string;
  packageCode ?:string;
  confirmation ?:string;
  shipDate ?:Date;
  holdUntilDate ?:Date;
  weight ?:string;
  dimensions ?:string;
  insuranceOptions ?:string;
  internationalOptions ?:string;
  advancedOptions ?:string;
  tagIds ?:number[];
  userId ?:number;
  externallyFulfilled ?:number;
  externallyFulfilledBy ?:string;
  labelMessages ?:string;
  is_posted ?:string;
  posted_by ?:number;
  not_sync ?:number;
  sales_posted ?:number;
  split_order ?:number;
  skip_inventory ?:number;
  skip_sales_report ?:number;
  row_type ?:number;
  channel_id ?:number;
  total_order_cost ?:number;
  total_order_quantity ?:number;
  order_cost_details ?:string;
  source :string;
  status :number;
  shipstationOrderId ?:null;
  latest_shipstation_create_order_status ?:null;
  tags ?:ITag[];
  channel ?:string;
  shipOrderError ?:string;
  shippingStatus ?:ShippingStatus;
  shippingError ?:string;
  pullUpdateStatus ?:PullUpdateStatus;
  pullUpdateError ?:string;
  starred_description ?:string;
  order_channel ?:IOrderChannel;
  hasFlaggedTag ?:boolean;
  hasShippingLabel ?:boolean;
  warehouseGroup ?:IWarehouseGroup;
  destination_reference_identifier ?:string;
  pickingStatus ?:string;

  approval ?:IApproval | null;
}

export interface IOrderChannel {
  id :number;
  label :string;
}

export enum ShippingStatus {
  PENDING = 'PENDING',
  SHIPPING = 'SHIPPING',
  SHIPPED = 'SHIPPED',
  FAILED = 'FAILED',
}

export enum PullUpdateStatus {
  GETTING_UPDATES = 'Getting updates',
  UPDATED = 'UPDATED',
  FAILED = 'FAILED',
}

export enum SalesOrderSourcePlatform {
  LUMINOUS = 'luminous',
  SHIPSTATION = 'shipstation',
  SHOPIFY = 'shopify',
  SHIPKEY = 'shipkey',
  EDI = 'edi',
}

export interface OrderPickingPreviewInterface {
  fulfillmentStatus :boolean;
  orderItems :SalesOrderItemPickingInterface[];
  salesOrder :SalesOrder;
  pickingItems :PickingItemInterface[];
}

export interface SalesOrderItemPickingInterface extends SalesOrderItem {
  isFulfilled :boolean;
}

export interface SalesOrderItem {
  id :number;
  created_at :Date;
  updated_at :Date;
  mt_shipstation_order_id :number;
  orderItemId :number;
  lineItemKey :string;
  sku :string;
  name :string;
  imageUrl ?:string;
  weight :string;
  quantity :number;
  unitPrice :number;
  taxAmount :number;
  shippingAmount :number;
  warehouseLocation;
  options :string;
  productId :number;
  fulfillmentSku ?:string;
  adjustment :number;
  upc :string;
  createDate :Date;
  modifyDate :Date;
  orderDate :Date;
  paymentDate :Date;
  orderStatus :string;
  stock_id :number;
  kit_id :number;
  rfq_id :number;
  non_physical_item :number;
  ignore_item :number;
  quantity_shipped :number;
  quantity_cancelled :number;
  ordered_qty :number;
  base_uom_id :number;
  ordered_uom_id :number;
  rfq :RFQ;
  kit :any;
  ordered_uom :UnitMeasureInterface;
  base_uom :UnitMeasureInterface;
  picking_status :string;
  picklist_item :any;
}

export interface FulfillmentStatus {
  totalUnfulfilled :number;
  ordersWithStocks :number;
  ordersWithoutStocks :number;
}
